import React from "react";
import { Tooltip } from "@mui/material";
import SyncProblemIcon from "@mui/icons-material/SyncProblem";
import type { CalendarProvider } from "../../api/bookings";

interface CalendarSyncWarningProps {
  provider: CalendarProvider;
}

export const CalendarSyncWarning: React.FC<CalendarSyncWarningProps> = ({
  provider,
}) => {
  const label = provider
    ? `Calendar sync unavailable — ${provider} event may be out of sync`
    : "Calendar sync unavailable";

  return (
    <Tooltip title={label} placement="top">
      <span role="img" aria-label="calendar sync unavailable">
        <SyncProblemIcon
          fontSize="small"
          color="warning"
          sx={{ verticalAlign: "middle", ml: 0.5 }}
        />
      </span>
    </Tooltip>
  );
};
